import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IHistoryPageDataResult {
  fetch: {
    Common: {
      History: {
        Gallery: Array<{
          Image: {
            src: string;
          };
        }> | null;
        Background: string | null;
      } | null;
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithHistoryPageQueryProps = QueryResult<IHistoryPageDataResult>;

class HistoryPageQuery extends Query<IHistoryPageDataResult, IVariables> {}

const withHistoryPageQuery = <P extends WithHistoryPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithHistoryPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <HistoryPageQuery
      query={queries.GET_HISTORY_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </HistoryPageQuery>
  );
};

export default withHistoryPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withHistoryPageQuery.tsx